'use client';

import React, { useMemo, useEffect } from 'react';
import { CLASSNAME, useProductService } from '@skin-seoul/service';
import { getAvailableCategorizedProducts, type CategoryOption } from '../utils/getAvailableCategorizedProducts';
import CategoryButton from './CategoryButton';
import type { Currency } from '@skin-seoul/service';
import { Flex } from '@skin-seoul/design-system';
const MAX_CATEGORIES = 10;
interface CategoryFilterOption {
  id: string;
  name: string;
}
interface TopRankedCategoryFilterProps {
  selectedCategoryName?: string;
  onCategoryChange: (categoryName: string) => void;
  currency: Currency;
}
const TopRankedCategoryFilter = ({
  selectedCategoryName,
  onCategoryChange,
  currency
}: TopRankedCategoryFilterProps) => {
  const {
    useGetTopRankedProducts
  } = useProductService();
  const {
    data: productsData
  } = useGetTopRankedProducts({
    currency
  });
  const availableCategories: CategoryOption[] = useMemo(() => {
    return getAvailableCategorizedProducts(productsData?.products || []).slice(0, MAX_CATEGORIES);
  }, [productsData?.products]);
  const categoriesWithProducts: CategoryFilterOption[] = useMemo(() => {
    return availableCategories.map((category: CategoryOption, index: number) => ({
      id: `${index}-${category.name}`,
      name: category.name
    }));
  }, [availableCategories]);
  useEffect(() => {
    if (availableCategories.length > 0 && !selectedCategoryName) {
      onCategoryChange(availableCategories[0].name);
    }
  }, [availableCategories, selectedCategoryName, onCategoryChange]);
  return <Flex flexWrap={{
    base: 'nowrap',
    tablet: 'wrap'
  }} rowGap={2} columnGap={1} className={CLASSNAME.NOT_TRANSLATE} data-sentry-element="Flex" data-sentry-component="TopRankedCategoryFilter" data-sentry-source-file="TopRankedCategoryFilter.tsx">
      {categoriesWithProducts.map(category => <CategoryButton key={category.id} name={category.name} isSelected={selectedCategoryName === category.name} onClick={() => onCategoryChange(category.name)} />)}
    </Flex>;
};
export default TopRankedCategoryFilter;